export enum Align {
    left = 'left',
    center = 'center',
    right = 'right',
}
